import { render, staticRenderFns } from "./NewLeads.vue?vue&type=template&id=66a5d85c&scoped=true&"
import script from "./NewLeads.vue?vue&type=script&lang=js&"
export * from "./NewLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5d85c",
  null
  
)

export default component.exports